import Relations from "../shared/relations";
import RequiredInput from "../shared/required";
import AppearanceModal from "../shared/appearance";
import FitTextControl from "../shared/fit-text";

interface Props extends React.ComponentProps<"div"> {
  editorRef: React.RefObject<HTMLDivElement>;
  rightClickedElement: HTMLElement;
}

const SelectContextActions: React.FC<Props> = ({
  editorRef,
  rightClickedElement
}) => {
  return (
    <>
      <Relations editorRef={editorRef} rightClickedElement={rightClickedElement} />
      <RequiredInput rightClickedElement={rightClickedElement} />
      <AppearanceModal
        editorRef={editorRef}
        rightClickedElement={rightClickedElement}
        title="ظاهر"
        description="تنظیم رنگ، فونت، ترازبندی و اندازه انتخاب"
      />
      <FitTextControl rightClickedElement={rightClickedElement} />
    </>
  );
};
export default SelectContextActions;
